import type { SVGProps } from 'react';

export const Edit = (props: SVGProps<any>) => (
  <svg
    height="12px"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 12 12"
    width="12px"
    x="0px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    y="0px"
    {...props}
  >
    <title>{'edit icon'}</title>
    <g>
      <path
        className="st0"
        d="M7.4,1.5L1,7.8L0,12l4.2-1l6.3-6.3L7.4,1.5z M7.4,2.7l0.7,0.7L2.9,8.5C2.7,8.3,2.4,8.1,2,8
        		L7.4,2.7z M1.6,10.8c-0.1-0.2-0.2-0.3-0.4-0.4l0.4-1.7C2.4,9,3,9.6,3.3,10.4L1.6,10.8z M4,10C3.9,9.6,3.7,9.3,3.5,9.1l5.1-5.1
        		l0.7,0.7L4,10z"
        id="XMLID_8_"
      />
      <path
        className="st0"
        d="M10.8,4.4L7.6,1.2L8.9,0l0.2,0c1.5,0.2,2.7,1.4,2.9,2.9l0,0.2L10.8,4.4z M8.8,1.2l2,2l0.4-0.4
        		c-0.2-1-1-1.8-2-2L8.8,1.2z"
      />
    </g>
  </svg>
);
